/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 1/14/14
 * Time: 5:33 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("content-templates/content-gallery/canned/contentCannedTableLayout.tmpl");
    var Button = require("ui/button/Button");
    var Paging = require("ui/paging/Paging");
    var DropdownMenu = require("ui/dropdown-menu/DropdownMenu");

    var ACTIONS_SKILL_ID = "skills";

    var ContentCannedTableLayout = {};

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentCannedTableLayout = Marionette.Layout.extend({
            template: template,
            className: "content-gallery-layout",
            isRendered: false,
            regions: {
                tableRegion          : ".table-container",
                dialogContainerRegion: ".dialog-container"
            },
            ui: {
                viewContainer             : ".view-container",
                actionMenuContainer       : ".action-menu",
                pagingContainer           : ".paging-container",
                doneButton                : ".button-done",
                addNewContentWrap         : ".add-new-content-wrap"
            },
            uiComponents: {
                actionMenu: {
                    type: DropdownMenu,
                    options: {
                        el: "view.ui.actionMenuContainer",
                        align: DropdownMenu.ALIGN.RIGHT,
                        name: LE.translator.translate("LEFramework.global.captions.action"),
                        collection: "view._getActionsCollection",
                        tabindex: "1000",
                        nowrap: true
                    },
                    events: {
                        "change":"_onActionSelected"
                    }
                },
                doneBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.doneButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_done"
                    }
                },
                paging: {
                    type: Paging,
                    options: {
                        el: "view.ui.pagingContainer",
                        collection: "view._getGalleryCollection",
                        blockWrongPageNumber: true,
                        showClearSelection: true
                    },
                    events: {
                        "change:page": "_changePage"
                    }
                },
                addNewBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.addNewContentWrap",
                        permutation: Button.PERMUTATION.BTN
                    },
                    events: {
                        "click": "_onAddNewText"
                    }
                }
//                newContentDD: { //todo unmark when we have more than one type in addNew
//                    type: DropdownMenu,
//                    options: {
//                        el: "view.ui.addNewContentWrap",
//                        name: LE.translator.translate("LEContent.content.gallery.add.new.button"),
//                        collection: "view._getNewContentDDCollection",
//                        tabindex: "1000",
//                        position: DropdownMenu.POSITION.TOP,
//                        align: DropdownMenu.ALIGN.MIDDLE,
//                        buttonPermutation: DropdownMenu.BUTTON_PERMUTATION.PLUS
//                    },
//                    events: {
//                        "change":"onNewContentSelected"
//                    }
//                }
            },

            initialize: function (options) {
                this.channel = options.channel;
                this.isAcUser = options.isAcUser;
                this.listenTo(this.model,"change:type",this._updateViewWithChangedModel);
            },
            onRender: function () {
                LEContent.logger.debug("onRender ContentCannedTableLayout", "ContentCannedTableLayout:onRender");
                this.listenTo(this.model,"change:pageInfo.*",this._updatePagingComponent);
                this.listenTo(this, "page:closeButtonClick", this._closeWindowButtonClicked);
                this.listenTo(this.uiComponents.paging, "clearSelection", this._clearSelection);
                this.isRendered = true;
                this._updateViewWithChangedModel();
            },
            _updateViewWithChangedModel: function(){
                if(!this.isRendered){return;}
                this._showButtonsAccordingToModel();
                this._showActionsAccordingToModel();
                this._showClearItemSelectionAccordingToModel();
            },
            _showActionsAccordingToModel: function () {
                this.uiComponents.actionMenu.closeDropdown();  //todo on dev-refactor https://tlvjira:8443/browse/LE-25668
                this.uiComponents.actionMenu.setItems(this._getActionsCollection());
            },
            _showButtonsAccordingToModel: function () {
                this.ui.addNewContentWrap.show();
            },

            _showClearItemSelectionAccordingToModel: function () {
                this.uiComponents.paging.setShowClearSelection(true);
            },

            _updatePagingComponent: function(){
                this.uiComponents.paging.setInfo(this.model.getContentPageInfoCurrentPage(),this.model.getContentPageInfoTotal());
            },
            /**
             * Returns a collection of the action menu items
             * @returns {DropdownMenu.Collection}
             * @private
             */
            _getActionsCollection: function() {
                var actionsCollection = this.model.getActions();
                if (!this.isAcUser) {
                    actionsCollection.remove(actionsCollection.where({id: ACTIONS_SKILL_ID}));
                }
                return actionsCollection;
            },

            _getGalleryCollection: function () {
                return this.model.getOrganizedCollection();
            },
            /**
             * Handles the selected action
             * @param id
             */
            _onActionSelected: function(componentId, eventName, id){
                LEContent.logger.info("Content table: user clicked on menu action: " + id, "ContentCannedTableLayout:onActionSelected");
                switch (id) {
                    case "create":
                        this._onAddNewText();
                        break;
                    case "edit":
                        this.channel.trigger("contentCannedTableLayout:actions:edit");
                        break;
                    case "delete":
                        this.channel.trigger("contentCannedTableLayout:actions:delete");
                        break;
                    case "categories":
                        this.channel.trigger("contentCannedTableLayout:actions:categories");
                        break;
                    case "skills":
                        this.channel.trigger("contentCannedTableLayout:actions:skills");
                        break;
                    case "export":
                        this.channel.trigger("contentCannedTableLayout:actions:export");
                        break;
                    case "legacyExport":
                        this.channel.trigger("contentCannedTableLayout:actions:legacyExport");
                        break;
                    case "import":
                        this.channel.trigger("contentCannedTableLayout:actions:import");
                        break;
                    default:
                        break;
                }
            },

            _changePage: function (component,event,idx) {
                LEContent.logger.info("User asks to change page to " + idx, "ContentCannedTableLayout:_changePage");
                this.channel.trigger("contentCannedTableLayout:change:page",idx);
            },

            _done: function () {
                LEContent.logger.info("User clicked on 'done' button.", "ContentCannedTableLayout:_done");
                this.channel.trigger("contentCannedTableLayout:buttons:done");
            },
            _closeWindowButtonClicked: function (){
                LEContent.logger.info("User clicked on 'close window' button.", "ContentCannedTableLayout:_closeWindowButtonClicked");
                this.channel.trigger("contentCannedTableLayout:buttons:closeWindow");
            },

            onClose: function () {
                LEContent.logger.info("closing content gallery layout view", "ContentCannedTableLayout::onClose");
            },

            //---------------------------------------------
            _onAddNewText: function() {
                this.channel.trigger("contentCannedTableLayout:actions:add:new:text");
            },
//            _onAddNewVideo: function() {
//                this.channel.trigger("contentCannedTableLayout:actions:add:new:video");
//            },

            /**
             * Handles the selected action
             * @param id
             */
//            onNewContentSelected: function(componentId, eventName, id){
//                LEContent.logger.info("Content gallery table: user clicked on add new content action: " + id, "ContentCannedTableView:onNewContentSelected");
//                switch (id) {
//                    case "addText":
//                        this._onAddNewText();
//                        break;
////                    case "addVideo":
////                        this._onAddNewVideo();
////                        break;
//                    default:
//                        break;
//                }
//            },
            _clearSelection: function () {
                this.channel.trigger("paging:clear:AllSelection");
            }
        });
    });
    return ContentCannedTableLayout;
});
